import axios from '../../axios';
import { toast } from 'react-toastify';
import { CANCEL_E_INVOICE, CANCEL_E_WAY_BILL, GENERATE_E_INVOICE, GENERATE_E_WAY_BILL } from '../types';

export const generateEInvoice = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/ewayInvoice/einvoice-gen`, formData);

      if (res.data.code === 1) {
         dispatch({ type: GENERATE_E_WAY_BILL, payload: res.data.data });
         setTimeout(() => {
            toast.success('Invoice generated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err?.response?.data) {
         if (err?.response?.data?.message?.length > 0) {
            toast.info(
               <div>
                  <button onClick={() => toast.dismiss()}>Close All</button>
               </div>,
               {
                  closeOnClick: true,
                  autoClose: false,
               },
            );
            err?.response?.data?.message?.forEach((message) => {
               toast.error(message.ErrorMessage, {
                  closeOnClick: true,
                  autoClose: false,
               });
            });

            return err.response.data;
         } else {
            toast.error(err?.response?.data?.message);
            return err.response.data;
         }
      }
   }
};

export const cancelEInvoice = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/ewayInvoice/einvoice-cancel`, formData);

      if (res.data.code === 1) {
         dispatch({ type: CANCEL_E_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('cancel e-invoice successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
   }
};

export const generateEWayBill = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/ewayInvoice/eway-gen`, formData);

      if (res.data.code === 1) {
         dispatch({ type: GENERATE_E_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Invoice generated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
   }
};

export const cancelEWayBill = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/ewayInvoice/eway-cancel`, formData);

      if (res.data.code === 1) {
         dispatch({ type: CANCEL_E_WAY_BILL, payload: res.data.data });
         setTimeout(() => {
            toast.success('cancel e-way bill successfully!');
         }, 1000);

         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);

         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
   }
};
